// extracted by mini-css-extract-plugin
export default {"avatar":"request-decoration_avatar__wJiHf","avatarBox":"request-decoration_avatarBox__D0oJn","submit":"request-decoration_submit__72srI"};